module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/brand-design-a-b.json
// module id = 401
// module chunks = 255490432627201